export const selectIsPredOrGredUser = (user) => Boolean(user?.isPredUser || user?.isGredUser);